import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const featureToggleEnum = ['gap-sample-feature-toggle', 'session-record-edit', 'meetings', 'in-person-scribe', 'strategist', 'multi-session-transcripts', 'calendar-integration'] as const

export const featureToggleEnumSchema = z.enum(featureToggleEnum, { errorMap })
export type FeatureToggleEnum = z.output<typeof featureToggleEnumSchema>
